export default __webpack_public_path__ + "static/media/metamask.75a7ee34.svg";